import React from "react";

const MessageA3 = (props) => {
  return (
    <div style={{ display: "flex", width: "100%" }}>
      <div
        className="chat-text"
        style={{ margin: "10px 10px" }}
        dangerouslySetInnerHTML={{ __html: props.item.text }}
      ></div>
    </div>
  );
};

export default MessageA3;
